import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AvailableModals, closeModal } from '../modalSlice';
import { ReduxState, useAppDispatch } from '../../../store';
import { Modal } from 'antd';
import SkuRedistributionChangelog from '../../CalculationDetail/Editation/SkuRedistributionChangelog/SkuRedistributionChangelog';

const modalId = AvailableModals.SKU_REDISTRIBUTION_CHANGELOG;

const SkuRedistributionChangelogModal: React.FC = () => {
  const dispatch = useAppDispatch();

  const open = useSelector((state: ReduxState) => state.modal.openedModal === modalId);
  const modalData = useSelector((state: ReduxState) => state.modal.modalData[modalId]);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  if (!open) return null;
  if (!modalData) return null;
  return (
    <Modal
      title="Changes made to the original redistribution"
      centered
      open={true}
      width="80%"
      onCancel={handleClose}
      footer={null}
    >
      <SkuRedistributionChangelog calculationId={modalData.calculationId} />
    </Modal>
  );
};

export default SkuRedistributionChangelogModal;
